import { call, takeLatest } from "redux-saga/effects";
import BackendService from "services/BackendService";
import { securityVersionHistoryEntityActions } from "containers/App/modules/entities/securityVersionHistories/securityVersionHistoryEntity.slice";
import { api } from "containers/App/modules/async.saga";
import schemas from "containers/App/modules/api/schema";
import { parseFetchAllRequest, parseFetchAllSuccess } from "./securityVersionHistory.parsers";

function* fetchSecurityVersionHistories(action) {
	const request = parseFetchAllRequest(action.payload);
	yield call(api, {
		apiFn: BackendService.searchSecurityVersionHistories,
		parseSuccessResponseFn: parseFetchAllSuccess,
		schema: [schemas.securityVersionHistories],
		params: request,
		actions: [
			securityVersionHistoryEntityActions.fetchSecurityVersionHistoriesPending,
			securityVersionHistoryEntityActions.fetchSecurityVersionHistoriesSuccess,
			securityVersionHistoryEntityActions.fetchSecurityVersionHistoriesFailure,
		],
	});
}

export default function* watchSecurityVersionHistoriesSaga() {
    yield takeLatest(securityVersionHistoryEntityActions.fetchSecurityVersionHistories, fetchSecurityVersionHistories);
}
